/*
 * Lemonade Training Oy copy rights all right reserved.
 */

/* -- imports   */
import * as PRODUCT from "@lemonadetraining/web-shared/constants/ProductConst";

export default class ProductObj {
  productType = PRODUCT.TYPE.Programming;
  // ---------------------------------
  active = true;
  name = null;
  ownerName = null;
  ownerUID = null;
  description = null;
  pricing = null;
  images = [];
  coverArtURL = null;
  stripeAccountID = null;
  subscribers = [];
  // ---------------------------------
  programmingType = null; // if productType === ProgrammingProduct, this should not be null.
  isPT = false; // it is Personal Trainer Programming if isPT === true
  effortLevel = null; // programming product effort level
  // ---------------------------------
  isLemonadeProduct = false;

  // constructor
  constructor(name, productType, isLemonadeProduct = false) {
    this.productType = productType;
    this.name = name;
    this.isLemonadeProduct = isLemonadeProduct;
  }
}
